export const normalizeSbpId = (tokenId: string) => (tokenId.startsWith('sbp-') ? tokenId : `sbp-${tokenId}`);
